import {
	AdSlotEvent,
	slotService,
	slotTweaker,
	targetingService,
	utils,
	type AdSlot,
} from '@ad-engine/core';

const logGroup = 'Anyclip';

export class AnyclipBidsRefresher {
	public trySubscribingBidRefreshing(anyclipWidget: AnyclipWidget) {
		anyclipWidget.subscribe(() => this.onAdImpressionHandler(), 'adImpression');
	}

	private onAdImpressionHandler() {
		utils.logger(logGroup, 'AnyclipBidsRefresher: ad impression in Anyclip detected - refreshing');

		const slotName = 'incontent_player';
		const playerAdSlot = slotService.get(slotName);

		this.sendSignalToRemoveBids(playerAdSlot);
		slotTweaker.setDataParam(playerAdSlot, 'gptSlotParams', targetingService.dump(slotName));
	}

	private sendSignalToRemoveBids(playerAdSlot: AdSlot) {
		playerAdSlot.emit(AdSlotEvent.VIDEO_AD_IMPRESSION);
	}
}
